import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth, AUTH_STATE } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AcceptInvite from "@/pages/AcceptInvite";
import PlatformSelectTenant from "@/pages/PlatformSelectTenant";
import Dashboard from "@/pages/Dashboard";
import Workspaces from "@/pages/Workspaces";
import WorkspaceDetail from "@/pages/WorkspaceDetail";
import Users from "@/pages/Users";
import Projects from "@/pages/Projects";
import ProjectShell from "@/pages/ProjectShell";
import BacklogPage from "@/pages/project/BacklogPage";
import KanbanPage from "@/pages/project/KanbanPage";
import SprintsPage from "@/pages/project/SprintsPage";
import RecurrencesPage from "@/pages/project/RecurrencesPage";
import ReportsPage from "@/pages/project/ReportsPage";
import OverviewPage from "@/pages/project/OverviewPage";
import ArchivedTasksPage from "@/pages/project/ArchivedTasksPage";
import ProjectSettingsPage from "@/pages/project/ProjectSettingsPage";
import Settings from "@/pages/Settings";
import Reassignments from "@/pages/Reassignments";
import Reports from "@/pages/Reports";
import PlatformAdmin from "@/pages/PlatformAdmin";
import AdminLayout from "@/components/AdminLayout";

function Root() {
  const { user, state, platformMode } = useAuth();
  if (user === null) return null;
  if (platformMode && state === AUTH_STATE.NEEDS_TENANT) {
    return <Navigate to="/selecionar-empresa" replace />;
  }
  if (platformMode && state === AUTH_STATE.AUTHED_ADMIN_ONLY) {
    return <Navigate to="/administracao-global" replace />;
  }
  return <Navigate to={user ? "/dashboard" : "/login"} replace />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster richColors position="top-right" />
          <Routes>
            <Route path="/" element={<Root />} />
            <Route path="/login" element={<Login />} />
            <Route path="/cadastro" element={<Register />} />
            <Route path="/esqueci-senha" element={<ForgotPassword />} />
            <Route path="/redefinir-senha" element={<ResetPassword />} />
            <Route path="/aceitar-convite" element={<AcceptInvite />} />
            <Route path="/selecionar-empresa" element={<PlatformSelectTenant />} />

            <Route path="/dashboard" element={
              <ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>
            } />
            <Route path="/espacos" element={
              <ProtectedRoute><Layout><Workspaces /></Layout></ProtectedRoute>
            } />
            <Route path="/espacos/:id" element={
              <ProtectedRoute><Layout><WorkspaceDetail /></Layout></ProtectedRoute>
            } />
            <Route path="/projetos" element={
              <ProtectedRoute><Layout><Projects /></Layout></ProtectedRoute>
            } />
            <Route path="/projetos/:id" element={
              <ProtectedRoute><Layout><ProjectShell /></Layout></ProtectedRoute>
            }>
              <Route index element={<OverviewPage />} />
              <Route path="backlog" element={<BacklogPage />} />
              <Route path="kanban" element={<KanbanPage />} />
              <Route path="sprints" element={<SprintsPage />} />
              <Route path="recorrencias" element={<RecurrencesPage />} />
              <Route path="relatorios" element={<ReportsPage />} />
              <Route path="arquivadas" element={<ArchivedTasksPage />} />
              <Route path="configuracoes" element={<ProjectSettingsPage />} />
            </Route>
            <Route path="/usuarios" element={
              <ProtectedRoute roles={["admin", "manager"]}><Layout><Users /></Layout></ProtectedRoute>
            } />
            <Route path="/reatribuicoes" element={
              <ProtectedRoute roles={["admin"]}><Layout><Reassignments /></Layout></ProtectedRoute>
            } />
            <Route path="/relatorios" element={
              <ProtectedRoute><Layout><Reports /></Layout></ProtectedRoute>
            } />
            <Route path="/configuracoes" element={
              <ProtectedRoute><Layout><Settings /></Layout></ProtectedRoute>
            } />
            <Route path="/administracao-global" element={
              <AdminLayout><PlatformAdmin /></AdminLayout>
            } />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
